import { Select, SelectProps } from 'antd';
import { useEffect } from 'react';
import { useTariffsTableGet } from '../../../hooks/api/tariffs';

export default function TariffsSelect({ value, onChange, ...config }: Partial<SelectProps>) {
  const tariffsTableGet = useTariffsTableGet();

  useEffect(() => {
    if (!tariffsTableGet.data && !tariffsTableGet.loading) {
      tariffsTableGet.fetch({ page: 1, pageSize: 100 });
    }
  }, []);

  const options = tariffsTableGet.data?.data.map((t) => ({
    label: `${t.name} (${t.tariffId})`,
    value: t.name,
  })) || [];

  return (
    <Select
      {...config}
      mode="multiple"
      allowClear
      placeholder="Select tariff"
      options={options}
      loading={tariffsTableGet.loading}
      value={Array.isArray(value) ? value : value?.split(',')}
      onChange={onChange}
    />
  );
}
